document.addEventListener("DOMContentLoaded", function (event) {

  const fecha = document.querySelector("#fecha");
  const inicia = document.querySelector("#inicia");

  if (!document.getElementById("days-digit-1")) return;

    // La fecha final para el contador
    const finalDate = new Date("2026-10-03T07:00:00").getTime();

    const countdownInterval = setInterval(() => {
      const now = new Date().getTime();
      const distance = finalDate - now;

      if (distance < 0) {
        clearInterval(countdownInterval);
        const digits = document.querySelectorAll(
          '[id^="days-digit-"], [id^="hours-digit-"], [id^="minutes-digit-"]'
        );
        digits.forEach((digit) => (digit.textContent = "0"));
        if (fecha) fecha.classList.add("hidden");
        if (inicia) {
          inicia.classList.remove("hidden");
          inicia.classList.add("block");
        }
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));

      const formattedDays = String(days).padStart(3, "0");
      const formattedHours = String(hours).padStart(2, "0");
      const formattedMinutes = String(minutes).padStart(2, "0");
      
      // Actualizar los dígitos de los días de forma dinámica
      document.getElementById("days-digit-1").textContent = formattedDays[0];
      document.getElementById("days-digit-2").textContent = formattedDays[1];
      document.getElementById("days-digit-3").textContent = formattedDays[2];

      // Horas
      document.getElementById("hours-digit-1").textContent = formattedHours[0];
      document.getElementById("hours-digit-2").textContent = formattedHours[1];

      // Minutos
      document.getElementById("minutes-digit-1").textContent = formattedMinutes[0];
      document.getElementById("minutes-digit-2").textContent = formattedMinutes[1];
    }, 1000);
  
});